import { AVideoAspectRatio, AVideoType, type AVideoProps } from '../../atoms/AVideo/AVideo.types';
import { MButtonOverlayProps } from '../MButtonOverlay/MButtonOverlay.types';
import {
  DEFAULT_VIDEO_ERROR_MESSAGE,
  DEFAULT_PAUSE_VIDEO_LABEL,
  DEFAULT_PLAY_VIDEO_LABEL,
} from '../../utils/i18nConstants';

export enum MVideoBackgroundButtonPosition {
  Bottom = 'Bottom',
  Top = 'Top',
}

export const MVideoBackgroundErrorMessage = {
  Default: DEFAULT_VIDEO_ERROR_MESSAGE,
} as const;

export const MVideoBackgroundAriaLabel = {
  Pause: DEFAULT_PAUSE_VIDEO_LABEL,
  Play: DEFAULT_PLAY_VIDEO_LABEL,
} as const;

export interface MVideoBackgroundProps extends React.HTMLAttributes<HTMLDivElement> {
  buttonPosition?: MVideoBackgroundButtonPosition;
  fillContainer?: boolean;
  /** Whether video should begin playing automatically. Defaults to false for accessibility. */
  autoPlay?: boolean;
  aVideo: AVideoProps;
  mButtonOverlay?: MButtonOverlayProps & {
    imageOverlay?: 'True' | 'False' | boolean;
  };
}

export { AVideoType, AVideoAspectRatio };
export type MVideoBackgroundButtonPositionType = MVideoBackgroundButtonPosition;
